import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidMount() {
    // Draait de app 10s zonder crash, dan is de herstel-reload geslaagd en mag
    // een VOLGENDE deploy opnieuw één auto-reload gebruiken. Zonder dit wisde de
    // vlag nooit en kreeg de gebruiker bij elke volgende deploy het foutscherm.
    this.resetTimer = setTimeout(() => {
      if (!this.state.hasError) sessionStorage.removeItem('chunk-reload-attempted');
    }, 10000);
  }

  componentWillUnmount() {
    clearTimeout(this.resetTimer);
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    // ChunkLoadError treedt op wanneer de browser een oude main.js draait die
    // verwijst naar chunks die niet meer bestaan na een nieuwe deploy.
    // We forceren één hard reload zodat de nieuwe bundle binnenkomt.
    const isChunkError =
      error?.name === 'ChunkLoadError' ||
      /Loading chunk [\w-]+ failed/i.test(error?.message || '') ||
      /Loading CSS chunk [\w-]+ failed/i.test(error?.message || '');
    if (isChunkError && !sessionStorage.getItem('chunk-reload-attempted')) {
      sessionStorage.setItem('chunk-reload-attempted', '1');
      window.location.reload();
    }
  }

  handleRetry = () => {
    sessionStorage.removeItem('chunk-reload-attempted');
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px',
        }}>
          <div style={{
            background: 'rgba(255,255,255,0.05)',
            border: '1px solid rgba(239,68,68,0.3)',
            borderRadius: '12px',
            padding: '40px',
            maxWidth: '500px',
            width: '100%',
            textAlign: 'center',
            backdropFilter: 'blur(10px)',
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '16px' }}>⚠️</div>
            <h2 style={{ color: '#ffffff', margin: '0 0 12px 0', fontSize: '1.5rem' }}>
              Er ging iets mis
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.6)', margin: '0 0 24px 0' }}>
              Er is een onverwachte fout opgetreden. Probeer de pagina opnieuw te laden.
            </p>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
              <button
                onClick={this.handleRetry}
                style={{
                  padding: '12px 24px',
                  background: 'linear-gradient(135deg, #0D9488 0%, #0F766E 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                }}
              >
                Opnieuw proberen
              </button>
              <button
                onClick={() => window.location.href = '/'}
                style={{
                  padding: '12px 24px',
                  background: 'rgba(255,255,255,0.1)',
                  color: 'rgba(255,255,255,0.7)',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  cursor: 'pointer',
                }}
              >
                Naar homepagina
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
